import React from 'react';
import {Route, Switch} from 'react-router-dom';
import Usage from './usage/Usage';
import Site from './site/Site';
import Users from './users/Users';
import Files from './files/Files';
import ManageMindfiles from './manage-mindfiles/ManageMindfiles';
import CurrentMindfile from './current-mindfile/CurrentMindfile';
import UsageExplorer from "./usage/UsageExplorer";

class Admin extends React.Component {
  render() {
    return (
      <div style={{position:'relative', height:'100%'}}>
        <div style={
          {
            padding: '1rem',
            backgroundColor: "rgba(0, 62, 88, 0.025)",
            height: '100%'
          }}>
          <Switch>
            <Route exact path="/admin" component={UsageExplorer} key={0} />
            <Route path="/admin/usages" component={Usage} key="usages" />
            <Route path="/admin/usage-table" component={UsageExplorer} key="usage-table" />
            <Route path="/admin/site" component={Site} key="site" />
            <Route path="/admin/users" component={Users} key="users" />
            <Route path="/admin/files" component={Files} key="files" />
            <Route path="/admin/manage" component={ManageMindfiles} key="manage" />
            <Route path="/admin/current" component={CurrentMindfile} key="current" />
          </Switch>
        </div>
      </div>
    );
  }
}

export default Admin;
